import { viVN_ShipmentInformation } from './information';
import { viVN_ShipmentManagement } from './management';

export const viVN_Shipment = {
  ...viVN_ShipmentInformation,
  ...viVN_ShipmentManagement
};
